import moment from 'moment';
const getTodayDate = (siteSetting) => {
    // isDayClosureEnabled (auto closure) logic hataya — sirf manual day closure cover karna hai
    // var date = null
    // if (siteSetting.isDayClosureEnabled) {
    //     const countryCode = siteSetting.footerAddress && siteSetting.footerAddress.country ? siteSetting.footerAddress.country : "IND";
    //     const timeZone = timezoneConverter[countryCode];
    //     date = getStartDateForClosure(siteSetting.closureTime, timeZone);
    // }
    // let newDate = date ? moment(date).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY");
    return moment().format("DD-MM-YYYY")
}

const getRunningDateByOpenOrders = (siteSetting, dayClosureData) => {
    // console.log("siteSetting",siteSetting)
    // console.log("dayClosureData",dayClosureData)
    // var date = null
    // if (siteSetting.isDayClosureEnabled) {
    //     const countryCode = siteSetting.footerAddress && siteSetting.footerAddress.country ? siteSetting.footerAddress.country : "IND";
    //     const timeZone = timezoneConverter[countryCode];
    //     date = getStartDateForClosure(siteSetting.closureTime, timeZone);
    //     if (openOrders && openOrders.length > 0) { date = openOrders?.[0].date }
    // }
    // if (!date && openOrders && openOrders.length > 0) { date = openOrders?.[0].date }
    var date = null
    if (siteSetting.isManualDayClosure && (dayClosureData?.opType == 'TimeHasPassed' || dayClosureData?.opType == 'OPEN')) {
        date = dayClosureData?.opDate
    }
    let newDate = date ? moment(date).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY");
    return newDate
}

const checkDevice = () => {
  let Name = "Unknown OS";
  if (navigator.userAgent.indexOf("Win") != -1) Name = "Windows OS";
  if (navigator.userAgent.indexOf("Mac") != -1) Name = "Macintosh";
  if (navigator.userAgent.indexOf("Linux") != -1) Name = "Linux OS";
  if (navigator.userAgent.indexOf("Android") != -1) Name = "Android OS";
  if (navigator.userAgent.indexOf("like Mac") != -1) Name = "iOS";
  return Name;
};
const checkPlatformForTablet = () =>{
    if (screen.width >= 1024) {
     return  'desktop'
    } else if (screen.width <= 1025 && screen.width >= 700) {
     return  'tablet'
    } else {
     return 'mobile'
    }
}
const checkPlatformForTablet2 = () =>{
    if (screen.width > 1300) {
     return  'desktop'
    } else if (screen.width <= 1300 && screen.width >= 700) {
     return  'tablet'
    } else {
     return 'mobile'
    }
}

 const findDishInstructionsBySlug = (serviceList, serviceId) => {
    if (!serviceList || !Array.isArray(serviceList) || !serviceId) return []

    for (let s of serviceList) {
        // direct item match
        if (s.slugName === serviceId) {
            return s.dishInstructions || []
        }
        // variation match — dishInstructions parent product pe hota hai
        if (s.attachedVariations && s.attachedVariations.length > 0) {
            let match = s.attachedVariations.find(v => v.slugName === serviceId)
            if (match) {
                return s.dishInstructions || []
            }
        }
    }
    return []
}
 const getWaiterName=(waiterData,username)=>{
  let waiterName = null
    username && waiterData && waiterData.length>0 &&  waiterData.map((item)=>{
            if(item.username == username){
                waiterName = item.name
            }
        })
        return waiterName
    }
export{
    checkDevice, checkPlatformForTablet, getTodayDate, getRunningDateByOpenOrders,checkPlatformForTablet2,findDishInstructionsBySlug,getWaiterName
}
